<ng-container [ngSwitch]="loader.element">
  <img *ngSwitchCase="'image'"
    [ngSrc]="loader.value"
    [width]="loader.size"
    [height]="loader.size"
    data-test="mode-loader-image"
    priority
  />

  <capra-icon *ngSwitchCase="'icon'"
    [icon]="loader.value"
    width="{{ loader.size }}px"
    height="{{ loader.size }}px"
    data-test="mode-loader-icon"
  ></capra-icon>
</ng-container>
